import React from 'react'

export default function PrivacyPolicies() {
  return (
    <div>PrivacyPolicies</div>
  )
}
